module.exports = __webpack_public_path__ + "static/media/shen-portrait.75b1f90a.jpg";